import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '../../lib/icons';

// Reusable button following the design system.
// variants: primary (brown), secondary (outline), text (link w/ arrow)
const base =
  'inline-flex items-center justify-center gap-2 font-sans font-bold transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-paelbi-brown/40 focus-visible:ring-offset-2 focus-visible:ring-offset-paelbi-bg disabled:opacity-60';

const variants = {
  primary:
    'h-12 px-6 rounded-btn bg-paelbi-brown text-white hover:bg-paelbi-brown-dark hover:-translate-y-0.5 shadow-card',
  secondary:
    'h-12 px-6 rounded-btn border border-paelbi-brown/40 bg-transparent text-paelbi-ink hover:border-paelbi-brown hover:bg-white',
  ghost:
    'h-12 px-6 rounded-btn border border-paelbi-line bg-white text-paelbi-ink hover:border-paelbi-brown/50',
  text:
    'text-paelbi-ink hover:text-paelbi-brown font-semibold'
};

export function Button({
  as = 'button',
  to,
  href,
  variant = 'primary',
  icon,
  iconLeft,
  className = '',
  children,
  ...rest
}) {
  const cls = `${base} ${variants[variant] || variants.primary} ${className}`;
  const content = (
    <>
      {iconLeft && <Icon name={iconLeft} size={18} />}
      <span>{children}</span>
      {icon && <Icon name={icon} size={18} />}
    </>
  );

  if (to) return <Link to={to} className={cls} {...rest}>{content}</Link>;
  if (href) return <a href={href} className={cls} {...rest}>{content}</a>;
  const Tag = as;
  return <Tag className={cls} {...rest}>{content}</Tag>;
}

export default Button;
